// src/stores/dialog.store.ts
import { create } from 'zustand';

export type DialogKind = 'alert' | 'confirm' | 'prompt';

export type DialogRequest = {
  id: number;
  kind: DialogKind;
  title?: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  destructive: boolean;
  placeholder?: string;
  defaultValue?: string;
  resolve: (value: any) => void;
};

type DialogState = {
  current: DialogRequest | null;
  push: (req: Omit<DialogRequest, 'id'>) => void;
  resolveAndClose: (value: any) => void;
};

let nextId = 1;

export const dialogStore = create<DialogState>((set, get) => ({
  current: null,
  push: (req) => {
    // 단일 다이얼로그 정책: 새로 요청이 오면 이전 요청은 cancel 로 resolve
    const prev = get().current;
    if (prev) {
      try {
        if (prev.kind === 'confirm') prev.resolve(false);
        else if (prev.kind === 'prompt') prev.resolve(null);
        else prev.resolve(undefined);
      } catch { /* noop */ }
    }
    set({ current: { ...req, id: nextId++ } });
  },
  resolveAndClose: (value) => {
    const cur = get().current;
    if (!cur) return;
    set({ current: null });
    try { cur.resolve(value); } catch { /* noop */ }
  },
}));
